/** Day-first date/time (never US month-first), aligned with UI language. */
export function resolveSessionDateTimeLocale(i18nLanguage: string): string {
  const base = i18nLanguage.split('-')[0]?.toLowerCase() ?? 'en';
  if (base === 'fr') {
    return 'fr-FR';
  }
  return 'en-GB';
}

const SESSION_DATE_TIME_OPTIONS: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
};

export function formatClock(
  iso: string | null,
  locale: string,
  fallback = '-',
): string {
  if (!iso) {
    return fallback;
  }
  const date = new Date(iso);
  if (isNaN(date.getTime())) {
    return fallback;
  }
  return new Intl.DateTimeFormat(
    resolveSessionDateTimeLocale(locale),
    SESSION_DATE_TIME_OPTIONS,
  ).format(date);
}

export function formatDayClock(iso: string, locale: string): string {
  if (!iso) return '-';
  const date = new Date(iso);
  if (isNaN(date.getTime())) return '-';
  return new Intl.DateTimeFormat(
    resolveSessionDateTimeLocale(locale),
    SESSION_DATE_TIME_OPTIONS,
  ).format(date);
}

export function formatEnergy(kwh: number | null, locale: string): string {
  if (kwh == null) {
    return '-';
  }
  const amount = new Intl.NumberFormat(locale, {
    maximumFractionDigits: 1,
  }).format(kwh);
  return `${amount} kWh`;
}

export function formatMoney(amount: number, locale: string): string {
  if (amount == null) return '-';
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'EUR',
  }).format(amount);
}

export function formatReadingValue(
  value: number,
  unit: string,
  locale: string,
): string {
  if (value == null) return '-';
  const amount = new Intl.NumberFormat(locale, {
    maximumFractionDigits: 2,
  }).format(value);
  return `${amount} ${unit}`;
}

export function displayName(
  value: string | null | undefined,
  unknown = '-',
): string {
  if (!value) return unknown;
  const trimmed = value.trim();
  return trimmed || unknown;
}
